import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Auth } from 'aws-amplify';
import PageHeading from '../../../../common/Heading/PageHeading';
import { LeftGrid } from '../../../../Episode/Episode.Styled';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { ContentTitle } from '../../../../ui/styled';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import BackIcon from '../../../../common/Back/BackIcon';
import Dialog from '@mui/material/Dialog';
//import PrintAlertContainer from './PrintAlertDialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import {
  GridSection,
  GridEleven,
  GridLeft,
  GridRight,
  DialogHeader,
  DialogHeading,
} from '../../../Episode.Styled';
import {
  EPISODE_STS_ALERT_PRINT_URL
} from '../../../../../constants';
import { getPrintableAlert } from './PrintAlertApi';
import { useSelector } from 'react-redux';

const PrintAlertDialog = (props) => {
  const stsAlertFormData = useSelector((state) => state.stsAlertForm);
  const [user, setUser] = useState(null);
  const { open, setOpen, alertID } = props;
  const [alert, setAlert] = useState({});
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
        user?.signInUserSession.accessToken.jwtToken,
        stsAlertFormData?.alertID
     ]
  );

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
    .then((userData) => userData)
    .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {
    if (stsAlertFormData?.alertID) {
      var commonParams = `${EPISODE_STS_ALERT_PRINT_URL}${stsAlertFormData?.alertID}`;
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      const alert = await getPrintableAlert({
        commonParams,
        authorization,
      });
      //console.log(alert);
      setAlert(alert);
    }  
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      <DialogHeader>
        <DialogHeading variant='h5'></DialogHeading>
        <Box>
          <LeftGrid item xs={6}>
            <Button
              variant='contained'
              style={{ justifyContent: 'flex-end' }}
              onClick={() => handlePrint()}
            >
              Print
            </Button>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </LeftGrid>
        </Box>
        </DialogHeader>
        <Grid container ref={componentRef} px={2}>
          <GridSection container spacing={1} style={{ alignItems: 'center' }}>
            <Box sx={{ justifyContent: 'center' }}>
              <Box
                component="img"
                sx={{
                  display: 'flex', 
                  justifyContent: 'center',
                  height: 150,
                  width: 150,
                  maxHeight: { xs: 150, md: 150 },
                  maxWidth: { xs: 150, md: 150 },
                }}
                src="/westcare-logo.jpg"
              />
            </Box>
          </GridSection>  
          <Grid item xs={12}>  
            <Box sx={{ justifyContent: 'center' }} mt={-2}>
              <Typography sx={{ textAlign: 'center' }} variant="h3" >
                STATUS ALERT FORM
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={2}>  
            <Box pt={2}>
              <Typography variant="body" fontWeight="800">
                PROVIDER:
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={10}>  
            <Box pt={2}>
              <Typography variant="body" fontWeight="800">
                Please fax this form to the participant's STOP Case Manager and Parole Agent immediately
                following the participant's admission, discharge, injury, hospitalization, rules violation, negative
                behavior, leaving program against staff advice, etc.
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={2}>  
            <Box pt={2}>
              <Typography variant="body">
                AUTH TYPE:
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={10}>  
            <Box pt={2}>
              <Typography variant="body">
                {alert.altAthTyp === 6 ? 'Non-SAP' : alert.altAthTyp === 8 ? 'SAP' : ''}
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={2}>  
            <Box>
              <Typography variant="body">
                DATE:
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={1}>  
            <Box>
              <Typography variant="body">
                {new Date(alert.altDate).toLocaleDateString()}
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={6}>  
            <Box>
              <Typography variant="body">
                PLEASE KNOW THAT: &nbsp;<u>{alert.prtKey}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body">
                CDCR #: &nbsp;<u>{alert.epdIcnCDC}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={2}>  
            <Box>
              <Typography variant="body">
                TO:
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={4}>  
            <Box>
              <Typography variant="body">
                <u>{alert.cntKey}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body">
                <u>{alert.cmFax}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body">
                <u>{alert.cmPhone}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={2}>  
            <Box pt={2}>
              <Typography variant="body">
                
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={4}>  
            <Box>
              <Typography variant="body2">
                Case Manager
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body2">
                Fax
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body2">
                Phone
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={2}>  
            <Box>
              <Typography variant="body">
                TO:
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={4}>  
            <Box>
              <Typography variant="body">
                <u>{alert.prlContact}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body">
                <u>{alert.prlFax}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body">
                <u>{alert.prlPhone}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={2}>  
            <Box>
              <Typography variant="body">
                
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={4}>  
            <Box>
              <Typography variant="body2">
                Parole Agent
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body2">
                Fax
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body2">
                Phone
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={2}>  
            <Box>
              <Typography variant="body">
                FROM:
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={4}>  
            <Box>
              <Typography variant="body">
                <u>{alert.orgKey}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body">
                <u>{alert.cntPhone}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body">
                <u>{alert.cbpContact}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={2}>  
            <Box>
              <Typography variant="body">
                
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={4}>  
            <Box>
              <Typography variant="body2">
                Parole Agent
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body2">
                Fax
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Box>
              <Typography variant="body2">
                Phone
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>  
            <hr/>
          </Grid>  
          <Grid item xs={1}>  
            <Checkbox readonly checked={alert.altIncDate} />
          </Grid>  
          <Grid item xs={4}>  
            <Box pt={1}>
              <Typography variant="body">
                Missed appointment on: <u>{alert.altIncDate ? new Date(alert.altIncDate).toLocaleDateString() : ''}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={3}>  
            <Checkbox readonly checked={alert?.altAptType===1}/>
            <Typography variant="body">
                Intake/Assesment
              </Typography>
          </Grid>  
          <Grid item xs={2}>  
            <Checkbox readonly checked={alert?.altAptType===2}/>
            <Typography variant="body">
                Individual
              </Typography>
          </Grid>  
          <Grid item xs={2}>  
            <Checkbox readonly checked={alert?.altAptType===1}/>
            <Typography variant="body">
                Group
              </Typography>
          </Grid>
          <Grid item xs={5}>
          </Grid>
          <Grid item xs={2}>
            <Box mt={-2}>
              <Checkbox readonly checked={alert?.altAptType===4}/>
              <Typography variant="body">
                  Other
              </Typography>
            </Box>  
          </Grid>  
          <Grid item xs={5}>  
            <Typography variant="body">
                <u>{alert.AltAptTypOth}</u>
              </Typography>
          </Grid>  
          <Grid item xs={1}>  
            <Checkbox readonly checked={alert.altAdmDate} />
          </Grid>  
          <Grid item xs={4}>  
            <Box pt={1}>
              <Typography variant="body">
                Admitted to program on: <u>{alert.altAdmDate ? new Date(alert.altAdmDate).toLocaleDateString() : ''}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={1}>
            <Box pt={1}>  
              <Typography variant="body">
                Modality:
              </Typography>
            </Box>  
          </Grid>  
          <Grid item xs={6}>
            <Checkbox readonly checked={alert.AdmMod==='1'} />
            <Typography variant="body">
                Res
            </Typography>  
            &nbsp;&nbsp;&nbsp;<Checkbox readonly checked={alert.admMod==='2'} />
            <Typography variant="body">
                SLE
            </Typography>  
            &nbsp;&nbsp;&nbsp;<Checkbox readonly checked={alert.admMod==='3'} />
            <Typography variant="body">
                OPT
            </Typography>  
            &nbsp;&nbsp;&nbsp;<Checkbox readonly checked={alert.admMod==='4'} />
            <Typography variant="body">
                SMD
            </Typography>  
          </Grid>
          <Grid item xs={12}>  
            <Box sx={{ justifyContent: 'center' }}>
              <Typography sx={{ textAlign: 'center' }} variant="h6" >
                <u><i>Please fax copy of Release of Information upon admission</i></u>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={1}>  
            <Checkbox readonly checked={alert.altUATyp} />
          </Grid>  
          <Grid item xs={11}>  
            <Box pt={1}>
              <Typography variant="body">
                Submitted urinalysis which yielded positive for: <u>{alert.altUATyp}</u>
              </Typography>
              <Typography variant="body">
                on: <u>{alert.altUADate}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={1}>  
            <Checkbox readonly checked={alert.altEmerCareAt} />
          </Grid>  
          <Grid item xs={11}>  
            <Box pt={1}>
              <Typography variant="body">
                Sought emergency medical care at: <u>{alert.altEmerCareAt}</u>
              </Typography>
              <Typography variant="body">
                on: <u>{alert.altEmerCareDate}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={1}>  
            <Checkbox readonly checked={alert.altEmerCareAt} />
          </Grid>  
          <Grid item xs={11}>  
            <Box pt={1}>
              <Typography variant="body">
                Behavioral/ treatment issues exist which may necessitate a case conference. Please contact provider.
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={1}>  
          </Grid>  
          <Grid item xs={11}>  
            <Box mt={-2}>
              <Typography variant="body">
                <u>{alert.altCaseConf}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={1}>  
            <Checkbox readonly checked={alert.altDischDate} />
          </Grid>  
          <Grid item xs={4}>  
            <Box pt={1}>
              <Typography variant="body">
                Discharged from program on: <u>{alert.altDischDate ? new Date(alert.altDischDate).toLocaleDateString() : ''}</u>
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={1}>
            <Box pt={1}>  
              <Typography variant="body">
                Modality:
              </Typography>
            </Box>  
          </Grid>  
          <Grid item xs={6}>
            <Checkbox readonly checked={alert.dischMod==='1'} />
            <Typography variant="body">
                Res
            </Typography>  
            &nbsp;&nbsp;&nbsp;<Checkbox readonly checked={alert.dischMod==='2'} />
            <Typography variant="body">
                SLE
            </Typography>  
            &nbsp;&nbsp;&nbsp;<Checkbox readonly checked={alert.dischMod==='3'} />
            <Typography variant="body">
                OPT
            </Typography>  
            &nbsp;&nbsp;&nbsp;<Checkbox readonly checked={alert.dischMod==='4'} />
            <Typography variant="body">
                SMD
            </Typography>  
          </Grid>
          <Grid item xs={1}>  
            <Checkbox readonly checked={alert.altDischDate} />
          </Grid>  
          <Grid item xs={2}>  
            <Box pt={1}>
              <Typography variant="body">
                Discharge was: 
              </Typography>
            </Box>
          </Grid>  
          <Grid item xs={9}>
            <Checkbox readonly checked={alert.altDischRsn===1} />
            <Typography variant="body">
                Successful completion
            </Typography>
            &nbsp;&nbsp;&nbsp;<Checkbox readonly checked={alert.altDischRsn===2} />
            <Typography variant="body">
                Program termination
            </Typography>
          </Grid>  
          <Grid item xs={3}>  
          </Grid>  
          <Grid item xs={9}>
            <Box mt={-2}>
              <Checkbox readonly checked={alert.altDischRsn===3} />
              <Typography variant="body">
                  Medical*
              </Typography>
              &nbsp;&nbsp;&nbsp;<Checkbox readonly checked={alert.altDischRsn===4} />
              <Typography variant="body">
                  Removed by Parole Agent
              </Typography>
            </Box>  
          </Grid>  
          <Grid item xs={3}>  
          </Grid>  
          <Grid item xs={9}>
            <Box mt={-2}>
              <Checkbox readonly checked={alert.altDischRsn===5} />
              <Typography variant="body">
                  Other {alert.altDischOthRsn}
              </Typography>
            </Box>  
          </Grid>  
          <Grid item xs={12}>  
            <Typography>
              *Medical discharges must be submitted when participant has been admitted to a hospital or within 72 hours of leaving the program for medical treatment
            </Typography>
          </Grid>
          <Grid item xs={12}>  
            <hr/>
          </Grid>  
          <Grid item xs={12} pb={2}>  
            <Typography>
              Provider Staff Name:
            </Typography>
          </Grid>
          <Grid item xs={6}>  
            <Box sx={{ justifyContent: 'center' }}>
              <Typography sx={{ textAlign: 'center' }} variant="h6" >
                <u>{alert.cbpContact}</u>
              </Typography>
            </Box>  
          </Grid>
          <Grid item xs={6}>  
            <Box sx={{ justifyContent: 'center' }}>
              <Typography sx={{ textAlign: 'center' }} variant="h6" >
                ___________________________________
              </Typography>
            </Box>  
          </Grid>
          <Grid item xs={6}>  
            <Box sx={{ justifyContent: 'center' }}>
              <Typography sx={{ textAlign: 'center' }} variant="body2" >
                Print
              </Typography>
            </Box>  
          </Grid>
          <Grid item xs={6}>  
            <Box sx={{ justifyContent: 'center' }}>
              <Typography sx={{ textAlign: 'center' }} variant="body2" >
                Signature
              </Typography>
            </Box>  
          </Grid>
          <Grid item xs={12} pt={2}>  
            <Typography variant="body2">
              Printed: {new Date().toLocaleString()}
            </Typography>
          </Grid>
        </Grid>
    </Dialog>  
  );
};

export default PrintAlertDialog